import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import classNames from 'classnames';
import { getHighlightForCategory } from 'services/tableRowHelpers';
import styles from './tableRow.scss';

const TableRow = ({
  pin,
  rowId,
  data,
  match: { params: { state, category } },
  isTwoCol,
}) => (
  <tr
    key={rowId}
    className={classNames({
      [styles.tableRow]: true,
    })}
  >
    {data
      // This sort is a stub, @see PRB-567
      .sort(({ idx: a }, { idx: b }) => a - b)
      .map(({
        idx,
        fixed,
        formattedValue,
      }) => (
        <td
          key={idx}
          className={classNames(styles.cell,
            {
              [styles.fixed]: fixed && !isTwoCol,
              [styles.alignLeft]: isTwoCol && 0 === idx,
              [styles.highlightedCell]: pin ||
                getHighlightForCategory(category).toLowerCase() ===
                data[0].formattedValue.toLowerCase(),
              [styles.isCounty]: undefined !== state,
            }
          )}
        >
          {formattedValue}
        </td>
      ))}
  </tr>
);

TableRow.defaultProps = {
  isTwoCol: false,
};

TableRow.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      state: PropTypes.string,
      category: PropTypes.string,
    }).isRequired,
  }).isRequired,
  rowId: PropTypes.string.isRequired,
  pin: PropTypes.bool.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      idx: PropTypes.number.isRequired,
      fixed: PropTypes.oneOf(['left', 'right']),
      formattedValue: PropTypes.string.isRequired,
    })
  ).isRequired,
  isTwoCol: PropTypes.bool,
};

export default withRouter(TableRow);



// WEBPACK FOOTER //
// ./app/components/tableRow/index.js